import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import "./ChooseRole.css";

import bgImage from "../../assets/get-start.png";
import studentImg from "../../assets/student-img.png";
import tutorImg from "../../assets/tutor-img.png";

const ChooseRole = () => {
  const navigate = useNavigate();
  const [selectedRole, setSelectedRole] = useState(null);

  const handleCardClick = (role) => {
    setSelectedRole(role);
  };

  const handleSignupClick = () => {
    if (selectedRole) {
      localStorage.setItem("userRole", selectedRole);
      navigate("/signup");
    }
  };

  return (
    <div
      className="choose-role-section"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <Container>
        <Row className="choose-role-section-row g-0">
          <Col xs={12} md={5}>
            <Card
              className={`choose-role-section-card text-center ${
                selectedRole === "student" ? "selected" : ""
              }`}
              onClick={() => handleCardClick("student")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && handleCardClick("student")}
            >
              <Card.Img
                variant="top"
                src={studentImg}
                alt="Student"
                className="choose-role-section-card-img"
              />
              <Card.Body className="choose-role-section-card-body">
                <Card.Title className="choose-role-section-card-title">
                  I'm a Student
                </Card.Title>
                <Card.Text className="choose-role-section-card-text">
                 Learn new skills, complete courses, and achieve your career goals. 
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={12} md={5}>
            <Card
              className={`choose-role-section-card text-center ${
                selectedRole === "tutor" ? "selected" : ""
              }`}
              onClick={() => handleCardClick("tutor")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && handleCardClick("tutor")}
            >
              <Card.Img
                variant="top"
                src={tutorImg}
                alt="Tutor"
                className="choose-role-section-card-img"
              />
              <Card.Body className="choose-role-section-card-body">
                <Card.Title className="choose-role-section-card-title">
                  I'm a Tutor
                </Card.Title>
                <Card.Text className="choose-role-section-card-text">
                Teach, inspire, and help learners build practical skills. 
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Button */}
        <Row className="justify-content-end mt-4">
          <Col xs={12} md={3} className="choose-role-section-button">
            <Button
              className="choose-role-signup-btn"
              disabled={!selectedRole}
              onClick={handleSignupClick}
            >
              Signup
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ChooseRole;
